import React from 'react';


const data = [
  { id: 1, date: "2017-18", heading: 'AQAR Report', profileurl: 'https://static.muoninfotech.com/./assets/IQAC/AQAR REPORT 17-18.pdf' },
  { id: 2, date: "2018-19", heading: 'AQAR Report', profileurl: 'https://static.muoninfotech.com/./assets/IQAC/AQAR REPORT 18-19.pdf' },
  { id: 3, date: "2019-20", heading: 'AQAR Report', profileurl: 'https://static.muoninfotech.com/./assets/IQAC/AQAR-REPORT-2019-20.pdf' },
  { id: 4, date: "2020-21", heading: 'AQAR Report', profileurl: 'https://static.muoninfotech.com/./assets/IQAC/AQAR-REPORT-2020-21 (1).pdf' },
  { id: 5, date: "2021-22", heading: 'AQAR Report', profileurl: 'https://static.muoninfotech.com/./assets/IQAC/AQAR 2021-22.pdf' },
  { id: 6, date: "2023-24", heading: 'AQAR Report', profileurl: 'https://static.muoninfotech.com/./assets/AQAR _2023/AQAR 2023-24.pdf' },
];


const AqarReport = () => {
  return (
    <div className="container">
      {data.map((item) => (
        <div key={item.id} className="card my-3">
          <div className="card-body">
            <div className="row">
              <div className="col-md-3">
                <p>Year : {item.date}</p>
              </div>
              <div className="col-md-6">
                <h3>{item.heading}</h3>
              </div>
              <div className="col-md-3">
                <button className="btn btn-primary" type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = item.profileurl;
                  }}>Download</button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AqarReport;
